import { ShoppingBag, ExternalLink } from "lucide-react";

/**
 * Embedded Amazon product card for blog posts.
 * Caller passes image, title, brand, price, amazon_url (already affiliate-tagged).
 *
 * If `placeholder` is true, renders an empty styled card with a small note —
 * useful while the author fills in real Amazon picks.
 */
export const BlogProduct = ({
  image,
  title,
  brand,
  price,
  amazon_url,
  caption,
  placeholder = false,
  testid,
}) => {
  if (placeholder || !amazon_url) {
    return (
      <div
        data-testid={testid || "blog-product-placeholder"}
        className="my-8 p-8 border border-dashed border-[#E3C2B0]/30 rounded-sm bg-[#E3C2B0]/[0.03] text-center"
      >
        <ShoppingBag className="w-5 h-5 mx-auto text-[#E3C2B0]" strokeWidth={1.5} />
        <p className="mt-3 text-xs uppercase tracking-[0.3em] text-[#E3C2B0]">
          StyleMe Pick
        </p>
        <p className="mt-2 text-sm text-[#A8A6A1]">
          {caption || "Amazon product to be embedded here"}
        </p>
      </div>
    );
  }

  return (
    <a
      href={amazon_url}
      target="_blank"
      rel="noreferrer noopener"
      data-testid={testid || "blog-product"}
      className="my-10 grid sm:grid-cols-[180px_1fr] gap-6 p-5 border border-white/10 rounded-sm bg-[#13121A] hover:bg-[#181722] transition-colors no-underline group"
    >
      <div className="aspect-[3/4] sm:aspect-square bg-[#0A0908] overflow-hidden rounded-sm">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col justify-between">
        <div>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#E3C2B0]">
            StyleMe Pick
          </span>
          {brand && (
            <div className="mt-2 text-xs uppercase tracking-widest text-[#A8A6A1]">{brand}</div>
          )}
          <div className="mt-1 font-serif text-xl text-[#F7F5F2] leading-tight no-underline">
            {title}
          </div>
          {price && (
            <div className="mt-3 text-[#E3C2B0] text-lg font-serif">{price}</div>
          )}
        </div>
        <div className="mt-4 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#E3C2B0] no-underline">
          Shop on Amazon
          <ExternalLink className="w-3 h-3" strokeWidth={1.5} />
        </div>
      </div>
    </a>
  );
};

export default BlogProduct;
